import { render, staticRenderFns } from "./ArchiveAuctionLotDetail.vue?vue&type=template&id=88c4b1d8&scoped=true&"
import script from "./ArchiveAuctionLotDetail.vue?vue&type=script&lang=js&"
export * from "./ArchiveAuctionLotDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveAuctionLotDetail.vue?vue&type=style&index=0&id=88c4b1d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c4b1d8",
  null
  
)

export default component.exports